export default {
  menu: {
    addTips: '请在系统或目录下新增',
    editTips: '请选择要修改的菜单或目录',
    deleteTips: '请选择要删除的菜单或目录',
    insertTitle: '新增菜单',
    updateTitle: '修改菜单',
    insertBtnTitle: '新增按钮',
    updateBtnTitle: '修改按钮',
    filterPlace: '输入关键字进行过滤',
    namePlaceholder: '请输入名称',
    typePlaceholder: '请选择类型',
    urlPlaceholder: '请输入路由',
    sortPlaceholder: '请输入序号',
    remarkPlaceholder: '请输入备注',
    buttonUrlPlaceholder: '请输入执行方法',
    buttonStylePlaceholder: '请输入图标样式',
    emoticons: '请勿输入表情',
    blankSpace: '请勿输入空格',
    menunameNotEmpty: '名称不能为空',
    sortNoNotEmpty: '序号不能为空',
    menuUrlNotEmpty: '路由不能为空',
    menunameWordNumber: '长度在 1 到 40 个字符',
    remarkWordNumber: '长度在 1 到 400 个字符',
    buttonUrlNotEmpty: '执行方法不能为空',
    menuTree: '菜单树',
    menuDetail: '菜单信息',
    menuBtn: '菜单按钮',
    menuName: '名称',
    type: '类型',
    menuUrl: '路由',
    sortNo: '序号',
    remark: '备注',
    menu: '菜单',
    catalog: '目录',
    buttonUrl: '执行方法',
    buttonStyle: '图标样式',
    buttonType: '按钮类型',
    addTreeTips: '请选择要操作的菜单',
    editTreeTips: '请选择一条记录进行修改',
    deleteTreeTips: '请选择要删除的按钮',
    editBtnTips: '请点击一行记录进行修改',
    table: {
      btnName: '按钮名称',
      btnStyle: '图标(样式)',
      methodName: '方法名',
    },
    referenceType: '菜单引用类型',
    referenceTypePlaceholder: '请选择菜单引用类型',
    inner: '内部',
    guandata: '观远',
    outUrl: '外部URL',
    outUrlPlaceholder: '请输入外部URL',
    partnerType: '合作伙伴类型',
    partnerTypePlaceholder: '请选择合作伙伴类型',
  },
};
